import React from 'react'
import { useGetFaqListMutation, useGetFaqTypesMutation } from '../redux/faqs/faqsApiSlice';
import { toast } from 'react-toastify';
import { getErrorMessage } from '../utils/commonUtils';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../redux/store';
import { setFaqList, setFaqTypes } from '../redux/faqs/faqsSlice';

const useFaqs = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [getFaqTypes, { isLoading: getFaqTypesLoading }] = useGetFaqTypesMutation();
    const [getFaqList, { isLoading: getFaqListLoading }] = useGetFaqListMutation();

    const getFaqTypesAPI = async () => {
        try {
            const response = await getFaqTypes({}).unwrap();
            dispatch(setFaqTypes(response.result));
            return response.result;
        } catch (err: any) {
            const message = getErrorMessage(err);
            throw new Error(message);
        }
    };

    const getFaqListAPI = async (data: Record<string, any>) => {
        try {
            const response = await getFaqList(data).unwrap();
            dispatch(setFaqList(response.result));
            return response.result;
        } catch (err: any) {
            const message = getErrorMessage(err);
            throw new Error(message);
        }
    };

    return {
        getFaqTypesAPI,
        getFaqTypesLoading,
        getFaqListAPI,
        getFaqListLoading,
    };
}

export default useFaqs;
